export default __webpack_public_path__ + "static/media/GPKLS_150.f51bc308.jpg";